
import { useNotificationsManager } from './notifications/useNotificationsManager';
import { addNotification } from '@/services/notificationService';

// Экспортируем хук и функцию добавления уведомлений для использования в приложении
export const useNotifications = useNotificationsManager;

// Экспортируем функцию для прямого добавления уведомлений
export { addNotification };
